var _defs, _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSupabaseBig(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1580 305",
    width: 1580,
    height: 305,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "supabase-logo-wordmark--light-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "g1",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(109.363,45.867,-68.642,163.668,146.872,149.317)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#249361"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3ecf8e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g2",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(49.795,93.737,-106.899,56.787,98.426,83.075)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000000",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000000",
    stopOpacity: 0
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #1f1f1f } \n\t\t.s1 { fill: url(#g1) } \n\t\t.s2 { opacity: .2;fill: url(#g2) } \n\t\t.s3 { fill: #3ecf8e } \n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m412 181.4c1.6 15.2 15.5 41.3 55.7 41.3 35.1 0 51.9-22.3 51.9-44 0-19.6-13.3-35.6-39.7-41.1l-19-4c-7.3-1.4-12.2-5.5-12.2-12 0-7.6 7.6-13.3 17.1-13.3 15.2 0 20.9 10 22 17.9l30.2-6.8c-1.6-14.4-14.4-38.6-52.5-38.6-28.8 0-50 19.9-50 43.8 0 18.7 11.7 34.2 37.5 39.9l17.7 4.1c10.3 2.2 14.4 7.1 14.4 13 0 7.1-5.7 13.4-17.7 13.4-15.7 0-23.6-9.8-24.4-20.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m635.2 218.6h34.5c-0.5-4.6-1.4-13.9-1.4-24.2v-109.5h-36.1v77.7c0 15.5-9.3 26.4-25.3 26.4-16.8 0-24.5-12-24.5-26.9v-77.2h-36.1v84.5c0 29.1 18.5 52.7 50.8 52.7 14.2 0 29.7-5.4 37-17.9 0 5.4 0.5 11.7 1.1 14.4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m706.9 270.2v-185.3h35.1v16.3c6-10.3 20.9-19.3 41-19.3 39.2 0 61.8 29.9 61.8 69.6 0 40.5-25.3 70.4-63.1 70.4-18.5 0-32.1-7.4-38.6-16.3v64.6zm69-155.9c-18.4 0-33.4 13.8-33.4 37.5 0 23.6 15 37.7 33.4 37.7 18.5 0 33.2-13.8 33.2-37.7 0-23.7-14.7-37.5-33.2-37.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m905.2 141.7l32.9-4.9c7.6-1.1 10-4.9 10-9.5 0-9.5-7.3-17.4-22.5-17.4-15.8 0-24.5 10.1-25.6 21.7l-32-6.7c2.1-21 21.4-44.1 57.3-44.1 42.4 0 58.2 23.9 58.2 50.8v65.8c0 7.1 0.8 16.6 1.6 21.2h-33.1c-0.9-3.5-1.4-10.9-1.4-16-6.8 10.6-19.6 19.8-39.4 19.8-28.6 0-46-19.3-46-40.2 0-23.9 17.7-37.2 40-40.5zm42.9 22.8v-5.9l-30.1 4.6c-9.3 1.3-16.6 6.5-16.6 16.8 0 7.9 5.7 15.5 17.4 15.5 15.2 0 29.3-7.3 29.3-31z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m1019.9 218.6v-196.7h35.6v77.7c6-9.5 20.7-18.2 40.6-18.2 39.1 0 61.7 30.1 61.7 69.8 0 40.5-25 70.7-63.1 70.7-18.5 0-32.6-8.2-39.7-19.6v16.3zm68.5-104.9c-18.2 0-33.4 13.3-33.4 37.8 0 24.2 15.2 38 33.4 38 18.5 0 33.2-13.6 33.2-38 0-24.5-14.7-37.8-33.2-37.8z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m1218.2 141.7l32.9-4.9c7.6-1.1 10.1-4.9 10.1-9.5 0-9.5-7.4-17.4-22.6-17.4-15.8 0-24.5 10.1-25.6 21.7l-32-6.7c2.1-21 21.4-44.1 57.3-44.1 42.4 0 58.2 23.9 58.2 50.8v65.8c0 7.1 0.8 16.6 1.6 21.2h-33.1c-0.9-3.5-1.4-10.9-1.4-16-6.8 10.6-19.6 19.8-39.4 19.8-28.6 0-46-19.3-46-40.2 0-23.9 17.7-37.2 40-40.5zm43 22.8v-5.9l-30.2 4.6c-9.3 1.3-16.6 6.5-16.6 16.8 0 7.9 5.7 15.5 17.4 15.5 15.2 0 29.4-7.3 29.4-31z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m1321.5 181.4c1.7 15.2 15.5 41.3 55.7 41.3 35.1 0 52-22.3 52-44 0-19.6-13.3-35.6-39.7-41.1l-19-4c-7.4-1.4-12.3-5.5-12.3-12 0-7.6 7.6-13.3 17.1-13.3 15.3 0 21 10 22.1 17.9l30.1-6.8c-1.6-14.4-14.4-38.6-52.4-38.6-28.8 0-50 19.9-50 43.8 0 18.7 11.6 34.2 37.5 39.9l17.6 4.1c10.4 2.2 14.5 7.1 14.5 13 0 7.1-5.8 13.4-17.7 13.4-15.8 0-23.7-9.8-24.5-20.4z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m1577.6 180.3c-6.8 23.1-28 42.4-60.9 42.4-36.7 0-69-26.4-69-71.5 0-42.7 31.5-70.4 65.7-70.4 41.4 0 66.1 26.4 66.1 69.3 0 5.2-0.5 10.6-0.5 11.2h-95.7c0.8 17.6 15.7 30.4 33.7 30.4 16.8 0 26.1-8.4 30.4-20.4zm-33.7-43.7c-0.5-13.3-9.2-26.4-29.9-26.4-18.7 0-29.1 14.1-29.9 26.4z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m173.4 299.6c-7.8 9.8-23.6 4.4-23.8-8l-2.7-182.8h123c22.3 0 34.7 25.7 20.9 43.2z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s2",
    d: "m173.4 299.6c-7.8 9.8-23.6 4.4-23.8-8l-2.7-182.8h123c22.3 0 34.7 25.7 20.9 43.2z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s3",
    d: "m123.3 5.6c7.8-9.8 23.6-4.4 23.8 8.1l1.2 182.7h-121.5c-22.3 0-34.8-25.7-20.9-43.1z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupabaseBig);
export default __webpack_public_path__ + "static/media/supabase_BIG.c8d645537685bd4ce5e4c512dc857bac.svg";
export { ForwardRef as ReactComponent };